import { Button } from '@dev-spendesk/grapes';

import { useTranslation } from 'src/core/common/hooks/useTranslation';
import { routeFor, routes } from 'src/core/constants/routes';
import logout from 'src/core/utils/logout';

type Props = {
  companyId: string;
  hasAccessToMultiEntityHub: boolean;
};

export const NavBar = ({ companyId, hasAccessToMultiEntityHub }: Props) => {
  const { t } = useTranslation('global');

  return (
    <div className="fixed z-50 flex size-full h-64 items-center justify-between bg-background-primary-brand-default px-24">
      <div>
        {hasAccessToMultiEntityHub && (
          <Button
            variant="primaryBrand"
            className="MultiHubButton"
            text={t('organisation.reporting.links.button')}
            iconName="square-4"
            onClick={() => {
              window.location.href = routeFor(
                routes.ORGANISATION_REPORTING.path,
                {
                  company: companyId,
                },
              );
            }}
          />
        )}
      </div>
      <img
        width="148px"
        src="/static/img/logo_horizontal_white.svg"
        alt="spendeskLogo"
      />
      <div>
        <Button
          variant="secondaryNeutral"
          text={t('overdueInvoice.closedDoor.nav.logOut')}
          onClick={async () => {
            await logout();
          }}
        />
      </div>
    </div>
  );
};
